angular.module("Main").controller("MeineTermineController", ["$rootScope", "$scope", "$q", "$window", "$document", "$timeout", "$location", "$state", "$stateParams", "$localStorage", "$uibModal", "BookingService", "DialogService", "SessionService",
    "AuthenticationService",
    function ($rootScope, $scope, $q, $window, $document, $timeout, $location, $state, $stateParams, $localStorage, $uibModal, BookingService, DialogService, SessionService, AuthenticationService) {
        var vm = this;


        var loginHandler = $rootScope.$on("login", function (event, data) {
            checkLogin();
            vm.isLoggedIn = data;
        });

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData', 'shopData');
            unregisterEventHandler();
            $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        });

        checkLogin();
        getKursbuchungLayouKonfiguration();
        getKPConfig();

        function checkLogin() {
            vm.currentUser = $localStorage.user;
            if (!_.isEmpty(vm.currentUser)) {
                vm.memberNr = vm.currentUser.memberNr;
                vm.username = vm.currentUser.Firstname + " " + vm.currentUser.Lastname;
            }
        }

        BookingService.getMemberAppointments(vm.currentUser.uid).then(function (data) {
            vm.memberAppointments = data;
            _.forEach(vm.memberAppointments, function (appo) {
                appo.Ressourcen = _.join(_.map(_.map(appo.Ressourcenplaner_JT_Termin_Ressources, 'Ressourcenplaner_Ressource'), 'Trainer'), " ,");
                appo.Bezeichnung = appo.Typ.Terminart;
                appo.Datum = moment(appo.Start).format('DD.MM.YYYY');
                appo.Uhrzeit = moment(appo.Start).format("HH:mm") + " - " + moment(appo.Ende).format("HH:mm");

            })
        });

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            })
        }

        function getKPConfig() {
            BookingService.getKPConfig().then(function (data) {
                vm.kundenportalConfig = data;
            })
        }

        vm.goBack = function () {
            if (vm.kundenportalConfig.ZugangVomBuchungssystem) {
                $state.go('customer', {cid: SessionService.getAuthData()});
                $rootScope.$emit("login");
            } else {
                if ( $state.is("/meineterminekurs") || $location.path() === "/meineterminekurs") {
                    $state.go('kursplan', {cid: $stateParams.cid, id: $stateParams.id});
                }
                if($state.is("/meinetermineshop") || $location.path() === "/meinetermineshop") {
                    $state.go('shop', {cid: $stateParams.cid, id: $stateParams.id});
                }
                else if ( $state.is("/meineterminetermin") || $location.path() === "/meineterminetermin") {
                    $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id});
                }
            }
        }

    }]);